import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import Box from "@mui/material/Box";

function ErrorBoundary({ errorcode }) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "80vh",
      }}
    >
      <div>
        <img
          className="error-image"
          src="https://cdn-icons-png.flaticon.com/512/4539/4539472.png"
          alt=""
          style={{ height: "150px" }}
        ></img>
      </div>
      <Typography variant="h4">An Error has Occurred {errorcode}</Typography>
      <div style={{ mt: 1 }}>
        <Button onClick={() => navigate("/")}>Take me back to safety</Button>
      </div>
    </Box>
  );
}

export default ErrorBoundary;
